import { AppleIcon } from '@hg/stylizator/icons'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

interface IAttributes {
  round?: boolean
  color?: string
}

const AppleIconBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <AppleIcon round={attributes.round} color={attributes.color} />
}

export default React.memo(AppleIconBlock, IWPGBlockAttributesCompare)
